// functions for handling [1,0,1] param value formatting and verifications
import {
  compressBinaryArray,
  decompressBinaryArray,
  stringToHash,
} from 'global-services/utils/OhsUtility';

// check if it matches the expected length, and if values are only 1s and 0s
export const validateParamBinaryArray = (
  input: number[] | null,
  expectedLength?: number
): boolean =>
  Array.isArray(input) &&
  input.every((val) => val === 0 || val === 1) &&
  (expectedLength === undefined || input.length === expectedLength);

// provide an array filter [1,0,1] and array of values
// 1 = return value, 0 = remove from array
export const filterByBinaryArray = (filter: number[] | null, values: string[] | null): string[] => {
  if (!filter || !values) return [];
  return values.filter((_, index) => filter[index] === 1);
};

// sort options id, convert to string, convert to hash then check if it matches hash basis
// ex usage: options that are dynamic, like workplaces
export const compareOptionsToHash = (hash: string, options: any[]) => {
  const sortedOption = [...options].sort();
  const stringOptions = JSON.stringify(sortedOption);
  const hashedOptions = stringToHash(stringOptions);
  return hash === hashedOptions;
};

// convert [1,0,1] from param to actual value array
export const formatBinaryStringToArray = ({
  param,
  hash,
  options,
  fallback = null,
}: {
  param: string | null;
  hash: string | null;
  options: any[];
  fallback?: any;
}) => {
  if (!hash || !param) return fallback;

  // verify if it matches hash
  const hashIsMatch = compareOptionsToHash(hash, options);
  if (!hashIsMatch) return fallback;

  // sort the options to match the binary array values
  const sortedOptions = [...options].sort();
  const binaryValue = decompressBinaryArray(param);

  // check if it matches length and is only 1s and 0s
  const isValid = validateParamBinaryArray(binaryValue, options.length);

  if (!isValid) return fallback;

  // assign values based on 1s and 0s
  const formattedParam = filterByBinaryArray(binaryValue, sortedOptions);

  return formattedParam;
};

// convert array value and options to [0,1,0] format, then encrypt
export const formatArrayBinaryToString = (values: string[], options: string[]): string => {
  const sortedOptions = options.sort();
  const binaryValue = sortedOptions.map((option) => (values.includes(option) ? 1 : 0));
  const compressedBinary = compressBinaryArray(binaryValue);
  return compressedBinary;
};
